import React from 'react';

// import { Box, Link, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Circle from '@mui/icons-material/Circle';
import { Popup } from '@vis.gl/react-maplibre';

import { getIdFromTitle, getTypeFromTitle } from '../utils/textUtils';
import { useResponsive } from '../hooks/useResponsive';
import { useLabel } from '../hooks/useLabel';

const OPEN_STREET_API = 'https://www.openstreetmap.org';

export const PopupLayer = ({
  lngPopup,
  latPopup,
  handleFeature,
  feature,
  closePopup,
}) => {
  const { isDesktop, isMobile } = useResponsive();
  const { convertLabelLayer } = useLabel();

  const renderColorCircle = (id) => {
    switch (id) {
      case 'drawn':
        return '#42A5F5';
      case 'described':
        return '#FF7043';
      case 'theoretical':
        return '#A9A7A7';
      case 'no_sidewalk':
        return '#FF0000';
      case 'walk':
        return '#36CF11';
      case 'walk_cycle':
        return '#51ACC2';
      case 'crossing_point':
        return '#F9B357';
      case 'crossing_path':
        return '#A455FF';
      default:
        return null;
    }
  };

  const style = {
    popupContainer: {
      display: 'flex',
      maxHeight: isDesktop ? 600 : 400,
      width: '100%',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      pointerEvents: 'auto',
    },
    container: {
      display: 'flex',
      width: '100%',
      height: '100%',
      // alignItems: 'center',
      paddingX: '1em',
      maxWidth: '240px',
    },
    contentContainer: {
      display: 'flex',
      overflowY: 'auto',
    },
    infoContainer: {
      display: 'flex',
      gap: 2,
      maxWidth: '240px',
      flexDirection: 'column',
    },
    titleType: {
      fontSize: isMobile ? '.9em' : null,
      fontWeight: 600,
    },
    typeRoadContainer: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
    },
    typeRoadLabel: {
      fontSize: isMobile ? '.9em' : null,
      paddingTop: isMobile ? '.2em' : null,
    },
    infoLabel: {
      fontSize: isMobile ? '.9em' : null,
      wordBreak: 'break-word',
    },
  };

  const renderContent = () => {
    if (feature !== undefined && feature !== null) {
      const { properties } = feature;
      return (
        <Box sx={style.container}>
          <Stack
            sx={style.contentContainer}
            direction='column'
            spacing={isMobile ? 1 : 2}
          >
            <Box>
              <Typography sx={style.titleType}>
                {getTypeFromTitle(properties.id)}
                <Link
                  href={`${OPEN_STREET_API}/${properties.id}`}
                  rel='noopener noreferrer'
                  target='_blank'
                >
                  {getIdFromTitle(properties.id)}
                </Link>
              </Typography>
            </Box>
            <Box sx={style.typeRoadContainer}>
              <Circle
                sx={{
                  fontSize: '1em',
                  marginRight: '1em',
                  fill: renderColorCircle(feature.layer.id),
                }}
              />
              <Typography sx={style.typeRoadLabel}>
                {convertLabelLayer(feature.layer.id)}
              </Typography>
            </Box>
            <Box sx={style.infoContainer}>
              {Object.keys(properties)
                .filter((prop) => prop !== 'id')
                .map((prop, index) => (
                  <Box key={index} sx={{ display: 'flex' }}>
                    <Typography sx={style.infoLabel}>
                      {prop} = {properties[prop]}
                    </Typography>
                  </Box>
                ))}
            </Box>
          </Stack>
        </Box>
      );
    } else {
      return;
    }
  };

  return (
    <Popup
      latitude={latPopup}
      longitude={lngPopup}
      anchor='left'
      closeOnClick={false}
      onClose={() => {
        handleFeature(undefined);
        closePopup();
      }}
      maxWidth='300px'
      style={style.popupContainer}
      closeButton={true}
    >
      {feature && renderContent()}
    </Popup>
  );
};
